import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { InputField } from "veronica-ui-component/dist/component/core";

export const OffStdMeasurementModeAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <InputField
                        label={`Off Std Measurement Mode`}
                        width='330px'
                        type="text"
                        maxLength={50}
                        value={chargeBatchUpdate.offStdMeasurementMode || ''}
                        onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'offStdMeasurementMode', chargeBatchUpdate, 'chargeBatchUpdate')}
                        allowedSpecialChars={'all'} />
                </div>
            </div>
        </>
    )
}